import { useRef, type FC } from "react";

import BlackstoneLogoUrl from "@/assets/customer-logos/Blackstone-logo.svg";
import BNYLogo from "@/assets/customer-logos/BNY_Logo.svg?raw";
import EquipmentShareLogo from "@/assets/customer-logos/EquipmentShare.svg?raw";
import OnaLogo from "@/assets/customer-logos/Ona-logo.svg?raw";
import PearsonLogo from "@/assets/customer-logos/Pearson_Logo.svg?raw";
import VantaLogoUrl from "@/assets/customer-logos/Vanta-logo.svg";
import { DotGridCanvas } from "@/components/backgrounds/DotGridCanvas";

const CUSTOMER_LOGOS: ({ alt: string } & ({ svg: string } | { src: string }))[] = [
    { src: VantaLogoUrl, alt: "Vanta" },
    { svg: OnaLogo, alt: "Ona" },
    { svg: BNYLogo, alt: "BNY" },
    { src: BlackstoneLogoUrl, alt: "Blackstone" },
    { svg: PearsonLogo, alt: "Pearson" },
    { svg: EquipmentShareLogo, alt: "EquipmentShare" },
];

export const LoginQuotePanel: FC = () => {
    const contentRef = useRef<HTMLDivElement>(null);

    return (
        <div className="relative flex h-full w-full items-center justify-center bg-surface-base p-8 lg:p-16">
            <DotGridCanvas rippleOriginRef={contentRef} />
            <div ref={contentRef} className="relative z-10 flex flex-col items-center gap-6">
                <p className="text-md font-medium tracking-wide text-content-secondary">
                    Ona delivers up to 90% of merged pull requests
                </p>
                <div className="grid grid-cols-2 gap-8 lg:grid-cols-3 lg:gap-x-12 lg:gap-y-10">
                    {CUSTOMER_LOGOS.map((logo) =>
                        "svg" in logo ? (
                            <div
                                key={logo.alt}
                                role="img"
                                aria-label={logo.alt}
                                className="flex h-7 w-24 items-center justify-center text-content-strong opacity-50 lg:w-28 [&>svg]:max-h-full [&>svg]:max-w-full"
                                dangerouslySetInnerHTML={{ __html: logo.svg }}
                            />
                        ) : (
                            <div
                                key={logo.alt}
                                className="flex h-7 w-24 items-center justify-center opacity-50 lg:w-28"
                            >
                                <img src={logo.src} alt={logo.alt} className="max-h-full max-w-full" />
                            </div>
                        ),
                    )}
                </div>
            </div>
        </div>
    );
};
